window.addEventListener('added-to-cart', event => {
    let shopBagMobileParent = document.getElementById('cart-button');
    let shopBagMobile = "";

    if (shopBagMobileParent != (null && undefined)) {
        shopBagMobile = document.getElementById('cart-button').querySelector('.icon-shopBag');
        shopBagMobile.classList.add('added-to-cart');

    }


    if (event.detail.id != "special") {
        let addToCart = document.getElementById('add-item-' + event.detail.id);
        addToCart.classList.add('added-to-cart');
        setTimeout(() => {
            if (shopBagMobileParent != (null && undefined)) {
                shopBagMobile.classList.remove('added-to-cart');
            }

            addToCart.classList.remove('added-to-cart');
            addToCart.classList.add('is-transition');

            setTimeout(() => {
                addToCart.classList.remove('is-transition');
            }, 100);
        }, 1900)
    } else {
        if (shopBagMobileParent != (null && undefined)) {
            setTimeout(() => {
                shopBagMobile.classList.remove('added-to-cart');
            }, 1900)
        }
    }
})